import React, { useContext } from "react";
import { css } from "emotion";
import { colors, boxStyles, textSizes } from "../../styles/theme";
import { GlobalContext } from "../../context/GlobalState";
import { AccountSettingsState } from "../../context/AccountSettingsState";

const ProfileDetails = () => {
  const { userData } = useContext(GlobalContext);
  const { setFirstName, setLastName, setEmailAddress } = useContext(
    AccountSettingsState
  );
  const data = useContext(AccountSettingsState);

  const handleChangeFirst = (e) => {
    const newValue = e.target.value;
    setFirstName(newValue);
  };

  const handleChangeLast = (e) => {
    const newValue = e.target.value;
    setLastName(newValue);
  };

  const handleChangeEmail = (e) => {
    const newValue = e.target.value;
    setEmailAddress(newValue);
  };

  return (
    <div className={container}>
      <div className="title">Profile Details</div>
      <div className="form">
        <div className="formItem">
          <div className="names">
            <div className="nameFirst">
              <label>
                <p>FIRST</p>
                <input
                  defaultValue={data.firstName}
                  onChange={handleChangeFirst}
                />
              </label>
            </div>
            <div className="nameLast">
              <label>
                <p>LAST</p>
                <input
                  defaultValue={data.lastName}
                  onChange={handleChangeLast}
                />
              </label>
            </div>
          </div>
        </div>
        <div className="formItem">
          <label>
            <p>EMAIL</p>
            <input
              defaultValue={data.emailAddress}
              onChange={handleChangeEmail}
            />
          </label>
        </div>
      </div>
    </div>
  );
};

export default ProfileDetails;

const container = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px 15px;

  p {
    padding: 5px 0;
  }

  .title {
    padding: 0 0 10px 10px;
  }

  .form {
    display: flex;
    flex-direction: column;
  }

  label {
    color: ${colors.placeholderText};
    font-size: ${textSizes.normal};
    flex: 1;
  }

  input {
    box-sizing: border-box;
    width: 100%;
    background-color: ${colors.inputBackground};
    padding: 10px;
    border: none;
    border-radius: ${boxStyles.borderRadius};
    color: ${colors.inputTextColor};
    font-size: ${textSizes.normal};
  }

  .formItem {
    display: flex;
    justify-content: space-between;
    padding: 10px 5px;
    flex: 1;
    .names {
      display: flex;
      flex: 1;
      justify-content: space-between;

      .nameFirst {
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: space-between;

        label {
          width: 95%;
        }

        input {
          flex: 1;
          background-color: ${colors.inputBackground};
          padding: 10px;
          border: none;
          border-radius: ${boxStyles.borderRadius};
          color: ${colors.inputTextColor};
          font-size: ${textSizes.normal};
          width: 100%;
        }
      }
      .nameLast {
        display: flex;
        flex-direction: column;
        flex: 1;

        label {
          align-self: flex-end;
          width: 95%;
        }

        input {
          flex: 1;
          background-color: ${colors.inputBackground};
          padding: 10px;
          border: none;
          border-radius: ${boxStyles.borderRadius};
          color: ${colors.inputTextColor};
          font-size: ${textSizes.normal};
          width: 100%;
          box-sizing: border-box;
        }
      }
    }
  }
`;
